module.exports = __webpack_public_path__ + "static/media/banner_iupp_viagem.006676ff.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/loyal-design-system/assets/images/banners/banner_iupp_viagem.png
// module id = 1544
// module chunks = 11